// extracted by mini-css-extract-plugin
export default {"section-container":"sbZpoD","title":"o1X1j2","weighted-filters-container":"DPuMCY"};